import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import type { Stores } from '../../../../../../util/store'
import styles from './start.module.scss'
import { Button } from '@mui/material'
import { useCallback, useState } from 'react'

interface WOModelManufacturerMatchStartProps {
    stores: Stores
}
export const WOModelManufacturerMatchStart = observer(
    ({ stores }: WOModelManufacturerMatchStartProps) => {
        const [autoMatchedModels, setAutoMatchedModels] = useState<number>()
        const navigate = useNavigate()
        const { manufacturerMatches, loading, modelPagination } =
            stores.manufacturerModelMatch

        const handleAutoMatchModelOnClick = useCallback(() => {
            setAutoMatchedModels(undefined)
            stores.manufacturerModelMatch
                .autoMatchModels()
                .then((result) => {
                    console.log('Auto matched models', result)
                    setAutoMatchedModels(result ? result.length : undefined)
                })
                .catch((e) => {
                    console.log('Failed to auto match models', e)
                })
        }, [stores.manufacturerModelMatch])
        return (
            <div data-testid="org-wo-mm-start-page" className={styles.container}>
                <div>
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        <div>
                            <p>{`Total manufacturers: ${manufacturerMatches.length}`}</p>
                            <p>{`Total models: ${modelPagination.total}`}</p>
                            {autoMatchedModels !== undefined && (
                                <p className={styles.resultText}>
                                    {`Auto matched: ${autoMatchedModels} models`}
                                </p>
                            )}
                        </div>
                    )}
                </div>
                <div className={styles.actionWrapper}>
                    <Button
                        disabled={loading}
                        className={styles.button}
                        onClick={handleAutoMatchModelOnClick}>
                        {loading ? 'Loading...' : 'Auto Match All Models'}
                    </Button>
                </div>
                <Button
                    disabled={loading}
                    className={styles.button}
                    onClick={() => {
                        navigate('../manufacturer-match-wizard')
                    }}>
                    {loading ? 'Loading...' : 'Start Matching Manufacturers'}
                </Button>
                <Button
                    disabled={loading}
                    className={styles.button}
                    onClick={() => {
                        navigate('../model-match-wizard')
                    }}>
                    {loading ? 'Loading...' : 'Start Matching Models'}
                </Button>
            </div>
        )
    },
)
